import React from "react";
import Email from "./email.js"

export default function Contact(){
    return(
        <div id="contactMe">
            <div className="container" id="contactInner">
                <div id="contactIntro">
                    <span className="eyebrow">Contact</span>
                    <h2 className="sectionTitle" id="collab">Let's build something.</h2>
                    <p id="quoteBody">
                        Have an interesting problem, a role, or a project worth building? I'd like to hear about it.
                    </p>
                    <a href="mailto:justShashank57@gmail.com" className="ctaPrimary" id="contactMailto">
                        justShashank57@gmail.com
                    </a>
                    <h3 id="findMe">Find me on</h3>
                    <div id="mediaHandles">
                        <a href="https://github.com/justShashank57" target="_blank" rel="noreferrer" className="socialIcon" aria-label="GitHub">
                            <img src="square-github.svg" alt="" />
                        </a>
                        <a href="https://www.linkedin.com/in/shashank-bidhuri-47a892249/" target="_blank" rel="noreferrer" className="socialIcon" aria-label="LinkedIn">
                            <img src="linkedin.svg" alt="" />
                        </a>
                        <a href="https://www.instagram.com/just_shashank__/" target="_blank" rel="noreferrer" className="socialIcon" aria-label="Instagram">
                            <img src="square-instagram.svg" alt="" />
                        </a>
                    </div>
                </div>
                <Email/>
            </div>
        </div>
    )
}
